<!-- routerLink is included through the RouterModule in AppModule imports -->
<a class="text-decoration-none" routerLink="{{path}}">
  {{name}}
</a>
